module.exports = __webpack_public_path__ + "pc-top-assets/img/facebook-black.e44d4dd6.svg";